export function promisifySynchronousMethod(methodToPromisify) {
    return new Promise((resolve) => resolve(methodToPromisify()));
}
//# sourceMappingURL=promisify-synchronous-method.js.map